import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { htmlContentToDraft, draftContentToHtml } from '../../../../utils/text-editor-util';

import HelpCenterMenu from '../help-center-menu/HelpCenterMenu';
import RichTextEditor from '../../../common/inputs/rich-text-editor/RichTextEditor';
import Button from '../../../common/button/Button';

import './frequently-asked-questions.scss';

const FrequentlyAskedQuestions = ({ isAdmin, frequentlyAskedQuestions, updateFrequentlyAskedQuestions }) => {
  const [editorState, setEditorState] = useState(undefined);

  useEffect(() => {
    if (frequentlyAskedQuestions) {
      setEditorState(htmlContentToDraft(frequentlyAskedQuestions));
    }
  }, [frequentlyAskedQuestions]);

  return (
    <section className="frequently-asked-questions">
      <HelpCenterMenu />

      <section className="frequently-asked-questions__content">
        <section className="frequently-asked-questions__header">
          <p className="frequently-asked-questions__title">Frequently Asked Questions</p>
          {isAdmin && (
            <Button onClick={() => updateFrequentlyAskedQuestions(draftContentToHtml(editorState))}>Save</Button>
          )}
        </section>

        {isAdmin ? (
          <section className="frequently-asked-questions__editor">
            <RichTextEditor editorState={editorState} setEditorState={setEditorState} />
          </section>
        ) : (
          <section
            className="frequently-asked-questions__questions"
            dangerouslySetInnerHTML={{ __html: frequentlyAskedQuestions }}
          />
        )}
      </section>
    </section>
  );
};

FrequentlyAskedQuestions.propTypes = {
  isAdmin: PropTypes.bool,
  frequentlyAskedQuestions: PropTypes.string,
  updateFrequentlyAskedQuestions: PropTypes.func.isRequired,
};

FrequentlyAskedQuestions.defaultProps = {
  isAdmin: false,
  frequentlyAskedQuestions: undefined,
};

export default FrequentlyAskedQuestions;
